import React from "react";

const PlusIcon = ({ isActive }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const fillColor = isActive ? "#FFFFF" : isHovered ? "#FFFFFF" : "#FFFFFF";

  return (
    <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {/* <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 27" fill="#1D4469">
        <rect x="0.5" width="27" height="25" rx="5" fill={isActive ? "#FFFFFF" : ""} />
        <path
          d="M19.8125 13.0125H15.0875V8.2875C15.0875 7.85258 14.7349 7.5 14.3 7.5C13.8651 7.5 13.5125 7.85258 13.5125 8.2875V13.0125H8.7875C8.35258 13.0125 8 13.3651 8 13.8C8 14.2349 8.35258 14.5875 8.7875 14.5875H13.5125V19.3125C13.5125 19.7474 13.8651 20.1 14.3 20.1C14.7349 20.1 15.0875 19.7474 15.0875 19.3125V14.5875H19.8125C20.2474 14.5875 20.6 14.2349 20.6 13.8C20.6 13.3651 20.2474 13.0125 19.8125 13.0125Z"
          fill={fillColor}
        />
      </svg> */}
      <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="1" width="26" height="26" rx="4.5" fill="var(--color-primary)" />
        <rect x="0.5" y="1" width="26" height="26" rx="4.5" stroke="#F0F5F9" />
        <path
          d="M18.3125 13.8125H14.1875V9.6875C14.1875 9.30781 13.8797 9 13.5 9C13.1203 9 12.8125 9.30781 12.8125 9.6875V13.8125H8.6875C8.30781 13.8125 8 14.1203 8 14.5C8 14.8797 8.30781 15.1875 8.6875 15.1875H12.8125V19.3125C12.8125 19.6922 13.1203 20 13.5 20C13.8797 20 14.1875 19.6922 14.1875 19.3125V15.1875H18.3125C18.6922 15.1875 19 14.8797 19 14.5C19 14.1203 18.6922 13.8125 18.3125 13.8125Z"
          fill="#F0F5F9"
        />
      </svg>
    </span>
  );
};

export default PlusIcon;
